import React from 'react';
import { Navigate, useRoutes } from "react-router-dom";

/* Pages Import */
import HomePage from "./pages/HomePage/HomePage"
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import FaqPage from './pages/FaqPage/FaqPage';
import ProjectsPage from './pages/ProjectsPage/ProjectsPage';
import ContactUsPage from './pages/ContactUsPage/ContactUsPage';
import AddProjectPage from './pages/AddProjectPage/AddProjectPage';
import MyProfilePage from './pages/MyProfilePage/MyProfilePage';
// import SwapPage from './pages/SwapPage/SwapPage';

export default function Router() {
  const routes = useRoutes([
    {
      path: "/",
      element: <HomePage />,
    },
    {
      path: "/projects",
      element: <ProjectsPage />,
    },
    // {
    //   path: "/swap",
    //   element: <SwapPage />,
    // },
    {
      path: "/contact-us",
      element: <ContactUsPage />,
    },
    {
      path: "/faq",
      element: <FaqPage />,
    },
    {
      path: "/add-project",
      element: <AddProjectPage />,
    },
    {
      path: "/profile",
      element: <MyProfilePage />,
    },
    {
      path: "/404",
      element: <NotFoundPage />,
    },
    {
      path: "*",
      element: <Navigate to='/404' replace />,
    },
  ]);

  return routes;
}
